<template> <!-- OK -->
    <div>
        <NavBar/>
        <PlayerManagement/>
    </div>
</template>


<script>

    import NavBar from '../components/NavBar.vue';
    import PlayerManagement from '../components/PlayerManagement.vue';

    export default {
        name: 'GerenciarJogadores',
        components: {
            NavBar,
            PlayerManagement
        }
    }

</script>